export function searchInArray(array: string[], prefix?: string | null, limit = 10): string[] {
  if (prefix === "") {
    return array.slice(0, limit + 1);
  }
  const chunk: string[] = [];
  for (let i = 0; i < array.length && chunk.length < limit; ++i) {
    if (prefix) {
      if (array[i].startsWith(prefix) || array[i].startsWith(prefix.toUpperCase())) {
        chunk.push(array[i]);
      }
    }
  }

  return chunk;
}

export function searchInNumArray(array: string[], prefix: string, limit = 10): string[] {
  const chunk: string[] = [];
  for (let i = 0; i < array.length && chunk.length < limit; ++i) {
    if (prefix) {
      if (array[i].startsWith(prefix)) {
        chunk.push(array[i]);
      }
    }
  }
  return chunk;
}
